export default __webpack_public_path__ + "static/media/SiriusXMLogo.1a479ea0.png";